import React, { useEffect, useState } from "react";
import TableHeading from "../../components/common/TableHeading";
import { RIGHTARROW_ICON } from "../../../utills/image-constant";
import Inputwithlable from "../../components/common/inputwithlable";
import DropDownWithLabel from "../../components/common/DropDownWithlable";
import {
  addCompany,
  getAllCountry,
} from "../../../services/api-services";
import { toastEmitter } from "../../../utills/utilities";
import { API_RESPONSE } from "../../../utills/app-constant";
import { handleFormInput } from "../../../utills/formutilities";
import Loginbtn from "../../components/common/loginbtn";
import { useLocation, useNavigate } from "react-router-dom";
import { ROUTES } from "../../routes/url-constant";
import {
  checkValidation,
  ErrorMessage,
  ErrorMsg,
} from "../../../utills/error-message-constant";
import {
  alphaletter,
  emailRegex,
  NumberRegex,
} from "../../../utills/form-regex";
import PhoneInput from "react-phone-input-2";

const AddCompany = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const Companytype = location?.state?.pageType;
  const CompanyViewData = location?.state?.Data;

  const [formError, setFormError] = useState({});
  const [CompanybtnLoader, setCompanybtnLoader] = useState(false);
  const [Companybtndisable, setCompanybtndisable] = useState(false);
  const [countryList, setCountryList] = useState([]);
  const [pending, setPending] = useState(false);

  const [companyData, setCompanyData] = useState({
    id: CompanyViewData ? CompanyViewData?.id : "",
    companyName: CompanyViewData ? CompanyViewData?.companyName : "",
    email: CompanyViewData ? CompanyViewData?.email : "",
    mobileNumber: CompanyViewData ? CompanyViewData?.mobileNumber : "",
    country: CompanyViewData ? CompanyViewData?.country : "",
    region: CompanyViewData ? CompanyViewData?.region : "",
    durationFrom: CompanyViewData ? CompanyViewData?.durationFrom : "",
    durationTo: CompanyViewData ? CompanyViewData?.durationTo : "",
  });

  useEffect(() => {
    if (location?.state?.Data) {
      const data = location.state?.Data;
      setCompanyData({
        ...data,
        companyColorRequestPayloadList:
          data.companyColorList?.map((item, index) => ({
            ...item,
            rangeFrom: index === 0 ? "0" : item.rangeFrom ?? "",
          })) || [],
      });
    }
  }, [location.state]);

  const getListOfCountry = async () => {
    try {
      setPending(true);
      const response = await getAllCountry();
      if (response?.data?.responseCode === 200) {
        const countryOptions = response?.data?.responseBody?.map((items) => ({
          value: items.name,
          label: items.name,
          Status: items.status,
        }));
        setCountryList(countryOptions);
      }
    } catch (err) {
      console.error(err);
    } finally {
      setPending(false);
    }
  };

  useEffect(() => {
    getListOfCountry();
  }, []);

  const handleSelect = (event) => {
    setCompanyData(handleFormInput(event, companyData));
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "email") {
      checkValidation(
        value,
        name,
        ErrorMessage?.Valid?.Email,
        emailRegex,
        formError,
        setFormError
      );
    }

    if (name === "mobileNumber") {
      checkValidation(
        value,
        name,
        ErrorMessage?.Valid?.MobileNumber,
        NumberRegex,
        formError,
        setFormError
      );
    }

    if (name === "region") {
      checkValidation(
        value,
        name,
        ErrorMessage?.Valid?.Region,
        alphaletter,
        formError,
        setFormError
      );
    }

    setCompanyData(handleFormInput(e, companyData));
  };

  const handleAddCompany = async () => {
    // prevent duplicate call
    if (CompanybtnLoader || Companybtndisable) return;

    // Validation
    if (
      !companyData?.companyName ||
      !companyData?.email ||
      !companyData?.country
    ) {
      toastEmitter("error", "All Fields Required");
      return;
    }

    if (formError?.emailStatus) {
      toastEmitter("error", "Please fill Valid Data");
      return;
    }

    const payload = {
      id: Companytype === "Edit" ? companyData.id : undefined,
      companyName: companyData?.companyName,
      email: companyData?.email,
      mobileNumber: companyData?.mobileNumber,
      country: companyData?.country,
      durationFrom: "",
      durationTo: "",
    };

    setCompanybtnLoader(true);
    setCompanybtndisable(true);

    try {
      const response = await addCompany(payload);
      if (response?.data?.responseCode === 200) {
        toastEmitter("success", response?.data?.message);
        navigate(ROUTES.COMPANYMANAGEMENT);
      } else {
        toastEmitter("error", response?.data?.message);
      }
    } catch (err) {
      toastEmitter("error", API_RESPONSE.MESSAGE_503);
    } finally {
      setCompanybtnLoader(false);
      setCompanybtndisable(false);
    }
  };

  const [isNumber, setIsNumber] = useState("us");

  const handleNumber = (e) => {
    setIsNumber(e);
    setCompanyData({ ...companyData, mobileNumber: e });
  };

  const handleNavigateBack = () => {
    navigate(ROUTES.COMPANYMANAGEMENT);
  };

  return (
    <>
      <TableHeading
        className="cursor-pointer"
        firstData="Customer Management"
        icon={RIGHTARROW_ICON}
        secondData="Company Management"
        iconshow={true}
        thirdData={
          Companytype === "Edit"
            ? "Update Company"
            : Companytype === "view"
            ? "View Company"
            : "Add Company"
        }
        onFirstDataClick={handleNavigateBack}
      />

      <div className="container-fluid">
        <div className="caspera_employee_add">
          <div className="row">
            <div className="col-md-6">
              <Inputwithlable
                placeHolder="Enter Company Name"
                name="companyName"
                type="text"
                showastrict={true}
                labelName="Enter Company Name"
                lableclassName="addInput-label"
                className="form-control addInputText-lable"
                handleChange={handleChange}
                error={formError?.companyName}
                value={companyData.companyName}
                disable={Companytype === "view"}
              />
              <ErrorMsg error={formError?.companyName} />
            </div>

            <div className="col-md-6">
              <Inputwithlable
                placeHolder="Enter Email"
                name="email"
                type="email"
                showastrict={true}
                labelName="Enter Email"
                lableclassName="addInput-label"
                className="form-control addInputText-lable"
                handleChange={handleChange}
                disable={Companytype === "view"}
                value={companyData?.email}
              />
              <ErrorMsg error={formError?.email} />
            </div>

            <div className="col-md-6 phoneinputdiv">
              <label htmlFor="inputState" className="form-label addInput-label">
                Enter Mobile Number
              </label>
              <PhoneInput
                country={isNumber}
                enableAreaCodes={true}
                value={companyData.mobileNumber}
                onChange={handleNumber}
                className="addInputText-lable"
                disabled={Companytype === "view"}
              />
              <ErrorMsg error={formError?.mobileNumber} />
            </div>

            <div className="col-md-6">
              <DropDownWithLabel
                labelName="Select Country"
                lableclassName="addInput-label"
                name="country"
                options={countryList}
                className="form-control addInputText-lable"
                value={companyData?.country}
                handleSelect={handleSelect}
                showastrict={true}
                disabled={Companytype === "view"}
              />
            </div>
          </div>

          <div className="pt-4 d-flex justify-content-center">
            {Companytype === "view" ? (
              ""
            ) : (
              <Loginbtn
                className="submitbtn px-5"
                type="button" 
                handleClick={handleAddCompany}
                btnName={Companytype === "Edit" ? "Update" : "Add Company"}
                disablebtn={Companybtndisable}
                loader={CompanybtnLoader}
              />
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default AddCompany;

